'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'couch';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f4b8';
var svgPathData = 'M560 48L80 48l0 144-16 0L64 48l0-16 16 0 480 0 16 0 0 16 0 144-16 0 0-144zM16 464l96 0 0-224-96 0 0 224zM0 224l16 0 96 0 16 0 0 16 0 48 384 0 0-48 0-16 16 0 96 0 16 0 0 16 0 224 0 16-16 0-96 0-16 0 0-16 0-32-384 0 0 32 0 16-16 0-96 0L0 480l0-16L0 240l0-16zM128 416l384 0 0-112-384 0 0 112zm400 48l96 0 0-224-96 0 0 224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCouch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;